import styles from './Maintance.module.scss';

const Maintance = () => {
  return (
    <div className={styles.container}>
      <div className={styles['circle-top-right']}></div>
      <div className={styles['circle-center']}></div>
      <div className={styles['circle-bottom-right']}></div>
      <div className={styles.contentWrapper}>
        <div className={styles.logo}>⚒️</div>
        <div className={styles.content}>
          <h1 className={styles.title}>Технические работы</h1>
          <p className={styles.description}>
            В данный момент ведутся <br /> технические работы.
          </p>
          <br />
          <p className={styles.description}>
            Пожалуйста, попробуйте зайти <br /> позже.
          </p>
        </div>
      </div>
    </div>
  );
};

export default Maintance;
